import React, { useRef, useState, useContext } from 'react'
import InputLabel from '@mui/material/InputLabel';
import { Formik, Form } from "formik";
import Grid from '@mui/material/Grid';
import * as Yup from 'yup';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import Container from '@mui/material/Container';
import DashboardForm from './DashboardForm';
import FormControl from '@mui/material/FormControl';
import Selectt from '@mui/material/Select';
import { MenuItem } from '@mui/material';
import SubmitButtonWrapper from '../addUser/SubmitBtn';
import TextfieldWrapper from './TextField';
import { ContextUser } from '../Context/UserContext';
import { ContextSheet } from '../Context/SheetContext';
import CheckBoxWrapper from './Inputs/CheckBox';
import Alert from '@mui/material/Alert';
import Snackbar from "@mui/material/Snackbar";
import IdleTimeOut from '../Session/IdleTimeOut';
import AutocompleteField from './Inputs/AutoComplete';


function Dashboard() {

  const value = useContext(ContextUser);

  const valueSheet = useContext(ContextSheet);


  const [FormValues, setFormValues] = useState(null);

  // const [open, setOpen] = React.useState(false);


  // const handleClick = () => {
  //   setOpen(true);
  // };

  // const handleClose = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpen(false);
  // };

  //severity={(valueSheet.alertMsg === 'error') ? 'error' : 'success'} 


  const AlertComponent = React.forwardRef((props, ref) =>
    <Alert elevation={6} severity={(valueSheet.alertMsg === 'error') ? 'error' : (valueSheet.alertMsg === 'warning') ? 'warning' : (valueSheet.alertMsg === 'info' ? 'info' : 'success')} variant="filled" {...props} ref={ref} />

  );

  const myRef = useRef(null);


  const initialFormState = {

    sheetNo: "",

  };



  const handleChange = (event) => {

    valueSheet.setSheetNameSelect(event.target.value);

    setFormValues({ sheetNo: event.target.value });

    if (!event.target.value) {

      valueSheet.setTableData([]);

    }

    else {

      let sheetName1 = valueSheet.firebaseData;
      let sheetNamee = sheetName1.filter((p) => p.SheetName === event.target.value);
      valueSheet.setChecked(sheetNamee[0].isInActive);

      valueSheet.setUserSelected(JSON.parse(sheetNamee[0].userAssign));
      valueSheet.setTableData(JSON.parse(sheetNamee[0].tableData));

      valueSheet.SetSheetCreatedBy(JSON.parse(sheetNamee[0].SheetCreatedBy));

      valueSheet.setFetchCreatedUser(JSON.parse(sheetNamee[0].SheetCreatedBy));

      valueSheet.setCreatedDate(sheetNamee[0].createdAt.toDate().toString());

      valueSheet.setUpdateMsg(sheetNamee[0].Status);

      valueSheet.setRoleUser(sheetNamee[0].Role);

      valueSheet.setUpdatedNameStatus(sheetNamee[0].SheetUpdatedBy);

    }


  };





  const formValidation = Yup.object().shape({



    sheetNo: Yup.string()
      .ensure()
      .required("*Sheet No. is required !!")
      .min(4, "*SheetName must be atleast 4 characters long !!"),
  })



  const clickElement = (ref) => {


    valueSheet.setTableData([]);

    if (valueSheet.sheetNameSelect.length === 0) {

      ref.current.dispatchEvent(
        new MouseEvent('click', { 
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        }),
      );
    }
    else {
      return false;
    }

  };




  const onClear = () => {
    valueSheet.setSheetNameSelect("");
    setFormValues({ sheetNo: '' });
    valueSheet.setUserSelected([]);
    valueSheet.setChecked(false);

  };



  const userr = sessionStorage.getItem("token");

  let getToken = sessionStorage.getItem('tokenRole');


  return (

    <React.Fragment>
      <br />
      <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        sx={{

          backgroundColor: 'primary.dark',
          '&:hover': {
            backgroundColor: 'primary.main',
            opacity: [0.9, 0.8, 0.7],
          },
        }}
      >

        <Typography variant="h4" component="h2" >
          Welcome " {userr} "
        </Typography>

      </Box>



      <Formik
        enableReinitialize
        initialValues={FormValues || initialFormState}
        validationSchema={formValidation}

        onSubmit={(values, { resetForm }) => {
          console.log(values);
          // valueSheet.postSheet();
          valueSheet.updateConfirmBoxBtn();
          // handleClick();
          // valueSheet.setShow(false);



          // resetForm({ values: '' });

          // setTimeout(() => {
          //   window.location.reload(false);
          // }, 2000);



        }}



      >

        <Form >

          <IdleTimeOut />

          <Box
            sx={{
              display: 'grid',
              gap: 1,
              gridTemplateColumns: 'repeat(1, 1fr)',
              // marginBottom: 5,
            }}
          >



            <Container maxWidth="lg" sx={{ marginTop: 5 }}>

              {/* <Grid container columnSpacing={{ xs: 1, sm: 5, md: 20, lg: 20 }} alignContent="left" justifyContent="left" sx={{ flexDirection: { xs: "column", md: "row" } }}  > */}
              <Box sx={{ width: '100%' }}>
                <Grid container spacing={2} columns={{ xs: 4, sm: 10, md: 12 }} sx={{ flexDirection: { xs: "column", md: "row" } }}>
                  <Grid item xs={6} >
                    <div >
                      <InputLabel id="demo-simple-select-standard-label">Select Sheets :</InputLabel>

                      <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                        <InputLabel id="demo-select-small">Sheet</InputLabel>
                        <Selectt
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={valueSheet.sheetNameSelect}
                          label="Sheet"
                          onChange={(e) => handleChange(e)}
                        // MenuProps={{ classes: { paper: classes.select } }}
                        // margin="normal"
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {/* <MenuItem value="Data">{valueSheet.sheetId}</MenuItem> */}
                          {valueSheet.sheetId.map((name, index) => {
                            return (
                              <MenuItem
                                key={index}
                                value={name}

                              >
                                {name}
                              </MenuItem>
                            );
                          })}
                        </Selectt>

                      </FormControl>



                    </div>

                  </Grid>
                  <Grid item xs={6}>
                    <div >

                      {getToken === 'superUser' ?
                        (
                          <AutocompleteField />

                          // <MultipleSelect />
                        )
                        :
                        (
                          null
                        )

                      }
                    </div>
                  </Grid>

                  <Grid item xs={6}>
                    <div>
                      {(valueSheet.show && valueSheet.sheetNameSelect.length === 0) ?

                        <>



                          < InputLabel id="demo-simple-select-standard-label"> Unique Sheet Name :</InputLabel>
                        </>
                        :
                        (
                          null
                        )
                      }
                      <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                        <TextfieldWrapper
                          name='sheetNo'
                          inputRef={valueSheet.sheetName}
                          hidden={(valueSheet.show && valueSheet.sheetNameSelect.length === 0) ? null : true}
                          label="New Sheet Name"



                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item xs={3}>

                  </Grid>
                </Grid>
              </Box>

              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>


                <Grid item xs={10}>
                  <div style={{ width: '100%' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 1,
                        m: 1,
                      }}
                    >


                      <div>



                        <Button variant='contained' color='primary' onClick={() => { clickElement(myRef); onClear(); valueSheet.setShow(true) }}>ADD NEW Sheet</Button>



                      </div>

                      <div style={{ marginLeft: '20px' }}>

                        {getToken === 'superUser' ?
                          (
                            <CheckBoxWrapper />

                          )
                          :
                          (
                            null
                          )

                        }
                      </div>

                    </Box>
                  </div>
                </Grid>

              </Grid>


            </Container>

          </Box>

          {(valueSheet.sheetNameSelect.length !== 0 && getToken !== 'user') ?

            (
              <>
                <br />
                <Box sx={{ width: '100%' }}>
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={6} >

                      <Typography variant="h6" gutterBottom align="left">
                        SHEET {valueSheet.updateMsg} BY :
                      </Typography>
                      <Typography letterSpacing='0.2em' textTransform='uppercase' marginLeft={2} variant="subtitle1" gutterBottom align="left">
                        {/* {displayCreatedBy} */}
                        {valueSheet.updatedNameStatus}
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <Typography variant="h6" gutterBottom align="left">
                        SHEET {valueSheet.updateMsg} AT :
                      </Typography>
                      <Typography marginLeft={2} variant="subtitle1" gutterBottom align="left">
                        {valueSheet.createdDate}
                      </Typography>
                    </Grid>


                  </Grid>
                </Box>

                <br />
              </>
            )
            :
            (
              null
            )
          }


          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              p: 1,
              // m: 1,
              bgcolor: 'background.paper',
              borderRadius: 1,
            }}
          >
            <Box sx={{ p: 2 }}>
              <SubmitButtonWrapper>Save Sheet</SubmitButtonWrapper>
            </Box>
            <Box sx={{ p: 2 }}>
              <Button onClick={() => { valueSheet.deleteConfirmBoxBtn() }} variant='contained' color='error'
              >Delete Sheet</Button>
            </Box>

          </Box>



          <DashboardForm myRef={myRef} />



        </Form>

      </Formik>




      <Snackbar open={valueSheet.open} autoHideDuration={3000}
        onClose={valueSheet.handleClose}
        // sx={{marginBottom:14}}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >

        <AlertComponent onClose={valueSheet.handleClose}
        >
          {valueSheet.statusMsg}

        </AlertComponent>


      </Snackbar>

    </React.Fragment >

  );
}

export default Dashboard;